<h4 class="page-title p-b-10">{{TR "Fernbedienung"}}</h4>
<div class="card-box clearfix">
    <div class="row">
        <div class="col-sm-4 col-xs-8 ">
            <button class="btn js-btn-run btn-default btn-remote m-t-5">
                <i class="fa fa-play"></i>
            </button>
            <button class="btn js-btn-stop btn-default btn-remote m-t-5">
                <i class="fa fa-stop"></i>
            </button>
        </div>
        <div class="col-sm-8 col-xs-4 js-remote-control-status">
        </div>
    </div>
    <div class="row m-t-10 visible-xs">
        <div class="col-xs-12">
            <span class="label label-default m-t-10 js-lbl-status"></span>
        </div>
    </div>
    <div class="row m-t-10">
        <div class="col-sm-12">
            <div class="remote-control">
                <div class="device" id="remote_device_container">
                    <div class="remote-device-type">5576</div>
                    <img id="remote_device_casing" />
                    <canvas id="remote-device-display_bmp" class="remote-device-display"></canvas>
                    <object id="remote-device-display_sym" class="remote-device-display" type="image/svg+xml"></object>
                    <button class="remote-control-knob btn">
                        <i class="fa fa-circle"></i>
                    </button>
                    <button class="remote-device-button-prog btn">
                        <i class="fa fa-circle"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
